module.exports = __webpack_public_path__ + "img/shift-alert.25f55d29.png";